
import { getRelatedProducts } from '~/graphql/queries.graphql'

export default {
  props: {
    currentSlug: {
      type: String,
      required: true,
    },

    mainCategory: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      products: [],
      options: {
        grabCursor: true,
        slidesPerView: 'auto',

        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },

        breakpoints: {
          0: {
            spaceBetween: 16,
          },

          768: {
            spaceBetween: 32,
          },
        },
      },
    }
  },

  async fetch() {
    const { entries } = await this.$graphql.cms.request(getRelatedProducts, {
      category: this.mainCategory,
      excludeSlug: this.currentSlug,
    })

    this.products = entries.data
  },
}
